<template>
    <div class="home-content"  v-loading="homeLoading" element-loading-background="rgba(0, 0, 0, 0.5)">
        <div class="home-login-gif">
            <!-- 内容点击区  居下四个块点击-->
            <div class="imgDiv" @click="headerImg">
               <img src="../../../assets/images/back.svg" alt="">
            </div>
            <div class="itemlink">
                <div class="items" v-for="(item, index) in routerLink" :key="index" >
                    <div class="key" @click="headerLink(item)" />
                </div>
            </div>
        </div>
    </div>
  </template>

<script>
// import api from '../api'
// import dayjs from 'dayjs'

export default {
  name: 'homeLogin',
  data () {
    return {
      homeLoading: false,
      routerLink: [
        { name: '运输A', link: '/homeSecurity' },
        { name: '运输B', link: '/homeSecurity' },
        { name: '运输C', link: '/homeSecurity' },
        { name: '军车调度管理系统', link: '/homeSecurity' }
      ]
    }
  },
  mounted () {
    this.setStaticData()
  },
  methods: {
    headerImg () {
      this.homeLoading = true
      setTimeout(() => {
        this.homeLoading = false
        this.$router.push({ path: '/homeContent' })
      }, 600)
    },
    headerLink (item) {
      this.homeLoading = true
      setTimeout(() => {
        this.homeLoading = false
        this.$router.push({ path: item.link })
      }, 600)
    },
    setStaticData () {
      const self = this
      // console.log('api, dayjs', api, dayjs)
      self.homeLoading = false
    }
  }
}
</script>

  <style lang="scss" scoped>
  .home-content {
    & > div {
      display: flex;
    }
  }
  .imgDiv {
      opacity: 0.8;
      position: absolute;
      right: 2rem;
      top: 0.6rem;
      img {
        height: 1.05rem;
        cursor: pointer;
      }
    }
    .imgDiv:hover {
      opacity: 1;
    }
  .home-login-gif {
    width: 100%;
    height: 100vh;
    background-color: #000;
    box-sizing: border-box;
    background: url("../../../assets/images/quanguo.gif") no-repeat;
    background-size: 100% 100%;
  }
  .home-login-gif:before {
    content: ' ';
    display: inline-block;
    width: 7%;
    height: 100vh;
    left: 0%;
    position: absolute;
    background-image: linear-gradient(to right, #060619, rgba(255,0,0,0));
  }
  .home-login-gif:after {
    content: ' ';
    display: inline-block;
    width: 7%;
    height: 100vh;
    right: 0%;
    position: absolute;
    background-image: linear-gradient(to right, rgba(255,0,0,0), #060619);
  }
  .itemlink {
    display: flex;
    width: 100%;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-around;
    align-items: flex-end;
    .items {
        cursor: pointer;
        flex: 1;
        height: 50%;
        // background: #6b7cc742;
        .key {
            height: 100%;
        }
    }
  }

  .home-left {
    width: 10.65rem;
    .overall {
      width: 100%;
      height: 1.53rem;
      padding: 0 0.28rem;
      box-sizing: border-box;
      background-size: 100% 100%;
      background: red;
    }
    // -
  }
  </style>
